var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.432 4A11.413 11.413 0 008 15.432c0 6.057 10.275 19.666 10.684 20.21.408.477 1.02.477 1.429 0 .476-.544 10.683-14.153 10.683-20.21C30.864 9.104 25.761 4 19.432 4zm-2.586 25.927h.273a.9.9 0 00.884-.885.9.9 0 00-.884-.885H15.62c-.34-.544-.748-1.157-1.088-1.769h2.518a.9.9 0 00.884-.885.9.9 0 00-.884-.884h-3.607c-2.042-3.539-3.675-7.077-3.675-9.187 0-5.308 4.287-9.663 9.663-9.663 5.308 0 9.663 4.287 9.663 9.663 0 4.151-6.396 13.814-9.663 18.237a106.824 106.824 0 01-2.586-3.742z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.06 9.444h-9.323a.9.9 0 00-.885.884v9.323a.9.9 0 00.885.885h9.322a.9.9 0 00.885-.885V10.33c.068-.477-.34-.885-.884-.885zm-.885 9.255H15.62v-7.486h2.859v1.701a.9.9 0 00.884.885.9.9 0 00.885-.885v-1.7h2.858v7.485h.068z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location-2.786b9cda.svg";
export { ForwardRef as ReactComponent };